import { createFileRoute } from "@tanstack/react-router";

import { AdminGuard } from "@/components/admin/AdminGuard";
import { AgentInstanceDetailPage } from "@/components/admin/agents/AgentInstanceDetailPage";

export const Route = createFileRoute("/admin/agents/$instanceId")({
  component: AgentInstanceDetailRoute,
});

function AgentInstanceDetailRoute() {
  const { instanceId } = Route.useParams();
  return (
    <AdminGuard>
      <AgentInstanceDetailPage instanceId={instanceId} />
    </AdminGuard>
  );
}
